import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      if(this.verifyErrors()) return

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      if(this.title.visible == 'Y') {
        this.canvasForms
        .append('text')
        .attr('x', this.title.x).attr('y', this.title.y + this.title.tSize*0.36)
        .attr('font-size', this.title.tSize).attr('fill', this.title.tColor)
        .text(this.title.name)
      }

      if(this.radio.visible == 'Y') this.draw_radioMenu()

      this.set_filterData()
      this.set_HeaderValue() // -----> set_LocalValues.js
      this.set_GroupValues() // -----> set_LocalValues.js
      this.set_DataColumns() // -----> set_LocalValues.js

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


    draw_radioMenu() {
      let radioGroup = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.radio.x}, ${this.radio.y})`)

      let x_ = 0 
      this.radio.list.forEach(d => {
        
        let stg = radioGroup
        .append('g')
        .attr('id', `RADIO_ITEM${d.id}_${this.localId}`)
        .attr('transform', `translate(${x_}, 0)`)
        .attr('opacity', d.id == this.current.id ? 1 : 0.8)
        .attr('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#RADIO_ITEM${d.id}_${this.localId}`).attr('opacity', 0.5) 
        })
        .on('mouseout', () => { 
          d3.select(`#RADIO_ITEM${d.id}_${this.localId}`).attr('opacity', d == d ? 1 : 0.8) 
        })
        .on('click', ()=> {
          if(this.current.id == d.id) return
          d3.select(`#RADIO_ITEM${this.current.id}_${this.localId}`).attr('opacity', 0.8) 
          d3.select(`#RADIO_TXT_${this.current.id}_${this.localId}`).attr('font-weight', 400).attr('fill', '#333')
          d3.select(`#RADIO_IN_${this.current.id}_${this.localId}`).attr('fill', '#fff')

          d3.select(`#RADIO_ITEM${d.id}_${this.localId}`).attr('opacity', 1) 
          d3.select(`#RADIO_TXT_${d.id}_${this.localId}`).attr('font-weight', 500).attr('fill', '#000')
          d3.select(`#RADIO_IN_${d.id}_${this.localId}`).attr('fill', '#F35E90')

          this.current = d
          this.canvasTable.remove()
          this.set_filterData()
          this.set_selectedItems()

          this.set_GroupValues() // -----> set_LocalValues.js
          this.set_DataColumns() // -----> set_LocalValues.js
        })
        
        stg
        .append('circle')
        .attr('transform', `translate(0,-0.5)`)
        .attr('r', 6).attr('stroke', '#F7BACF').attr('stroke-width', 1).attr('fill', '#fff')

        stg
        .append('circle')
        .attr('id', `RADIO_IN_${d.id}_${this.localId}`)
        .attr('transform', `translate(0,-0.5)`)
        .attr('r', 3).attr('stroke', '#F35E90').attr('stroke-width', 0)
        .attr('fill', this.current.id == d.id ? '#F35E90' : '#fff')

        stg
        .append('text')
        .attr('id', `RADIO_TXT_${d.id}_${this.localId}`)
        .attr('transform', `translate(11, ${0.5 + this.radio.tSize*0.36})`)
        .attr('font-size', this.radio.tSize).attr('fill', this.radio.tColor)
        .attr('font-weight', this.current.id == d.id ? 500 : 400)
        .attr('text-anchor', 'start')
        .text(d.name)

        x_ += this.getNode(`#RADIO_TXT_${d.id}_${this.localId}`, 'width') + 40
      })
    },

  }
}
